import { SORT_TYPE } from './SortAndFilter';

const SNAP_CATEGORY = {
  FLIGHT: 'SNAP - AirTickets',
  HOTEL: 'SNAP - Hotels',
};

const FLIGHT_TYPE = {
  INTERNATIONAL: 'international',
  DOMESTIC: 'domestic',
};

const TRIP_TYPE = {
  ONE_WAY: 'OW',
  RETURN: 'RT',
  MULTICITY: 'MC',
};

const FLIGHT_CONNECTION_TYPE = {
  FLIGHT_THROUGH: 'Fly-Through',
  DIRECT: 'Direct',
};

const FILTER_TO_HOTEL_SEARCH_RESULTS = {
  [SORT_TYPE.RECOMMENDED]: 'Hotel Search Results - Recommendation',
  [SORT_TYPE.PRICE_LOW_TO_HIGH]: 'Hotel Search Results - Price Low to High',
  [SORT_TYPE.PRICE_HIGH_TO_LOW]: 'Hotel Search Results - Price High to Low',
  [SORT_TYPE.USER_RATING]: 'Hotel Search Results - Guest Rating',
};

const FLIGHT_SEARCH_RESULTS = 'Flight Search Results - Lowest Fare';
const HOTEL_SEARCH_RESULTS = 'Hotel Search Results - Recommendation';

const BACK_FROM_GUEST_DETAIL_LABEL = 'Hotels-guest details back button';
const BACK_FROM_HOTEL_LIST_LABEL = 'Hotels-search result back button';
const BACK_DEFAULT_TRACKING_LABEL = 'Back button on mobile';

const ROOM_BED_TYPE = {
  SINGLE: 1,
  TWIN: 2,
  QUEEN: 3,
  KING: 4,
  FULL: 5,
};

const BREAKFAST_PROVISION = {
  PROVIDED: 'Provided',
  NOT_PROVIDED: 'Not Provided',
  INCLUDES_BREAKFAST: 'Includes breakfast',
};

const WIFI_PROVISION = {
  PROVIDED: 'Provided',
  NOT_PROVIDED: 'Not Provided',
  FREE_WIFI: 'Free Wifi',
};

const PAYMENT_METHOD_ECOMMERCE_GTM = {
  CREDIT_CARD: 'CC',
  DIRECT_DEBIT: 'DB',
  LOYALTY: 'LY',
  ZERO_PAYMENT: 'ZP',
  PROMO: 'PR',
  PAY_LATER: 'PL',
  BIGPAY: 'BP',
};

export {
  SNAP_CATEGORY,
  FLIGHT_TYPE,
  FLIGHT_CONNECTION_TYPE,
  FILTER_TO_HOTEL_SEARCH_RESULTS,
  FLIGHT_SEARCH_RESULTS,
  TRIP_TYPE,
  BACK_FROM_GUEST_DETAIL_LABEL,
  HOTEL_SEARCH_RESULTS,
  BACK_FROM_HOTEL_LIST_LABEL,
  BACK_DEFAULT_TRACKING_LABEL,
  ROOM_BED_TYPE,
  BREAKFAST_PROVISION,
  WIFI_PROVISION,
  PAYMENT_METHOD_ECOMMERCE_GTM,
};
